import { useMemo } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/auth";
import { Shield } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  const navState = useMemo(() => ({ from: location }), [location]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-obsidian">
        <Shield className="w-10 h-10 text-gold animate-pulse" />
      </div>
    );
  }

  if (!user) {
    // Redirect to landing page; preserve intended destination so login can bounce back.
    return <Navigate to="/" replace state={navState} />;
  }

  return children;
}
